// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gg-0";
export var headerCellHover = "_gg-1";
export var readCellContainer = "_gg-2";
export var unreadIndicator = "_gg-3";